import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractType } from './abstract-type';

@inheritSerialization(AbstractType)
export class SuspensionReason extends AbstractType {
  @autoserialize
  active: boolean;

  @autoserialize
  useWithRider: boolean;

  @autoserialize
  useWithDriver: boolean;

  @autoserialize
  permanent: boolean;
}
